module.exports = require('./helpers/bundle-url').getBundleURL('QXyrT') + "chevron-right.bded7e8d.svg";